export default class LoggerAction {

    static DEPLOY = 'DEPLOY';
    static RETOUR = 'RETOUR';
    static RELEASE = 'RELEASE';
    static REPAIR_PENDING = 'REPAIR_PENDING';
    static REPAIR_ACTIVE = 'REPAIR_ACTIVE';
    static WRITE_OFF = 'WRITE_OFF';
    static TRANSFER = 'TRANSFER';
    static REPLACE = 'REPLACE';
    static UPDATE_ACTION_DEADLINE = 'UPDATE_ACTION_DEADLINE';
}